document.addEventListener('DOMContentLoaded', function () {
  
  // Fetch settings from window.themeSettings
  const shopClosed = window.themeSettings.shopClosed;
  const registerOpenDateTime = window.themeSettings.registerOpenDatetime;
  const shopOpenDatetime = window.themeSettings.shopOpenDatetime;
  const shopCloseDatetime = window.themeSettings.shopCloseDatetime;

  // Parse datetime strings into Date objects
  const shopOpenDateTime = shopOpenDatetime ? new Date(shopOpenDatetime) : null;
  const shopCloseDateTime = shopCloseDatetime ? new Date(shopCloseDatetime) : null;
  
  const shopTimeZone = 'Europe/Berlin';

  // Utility: Convert a user's local time to the shop's timezone
  function toShopTime(date) {
    const formatter = new Intl.DateTimeFormat('en-US', {
      timeZone: shopTimeZone,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
    });

    const parts = formatter.formatToParts(date);
    const year = parts.find((part) => part.type === 'year').value;
    const month = parts.find((part) => part.type === 'month').value;
    const day = parts.find((part) => part.type === 'day').value;
    const hour = parts.find((part) => part.type === 'hour').value;
    const minute = parts.find((part) => part.type === 'minute').value;
    const second = parts.find((part) => part.type === 'second').value;

    return new Date(`${year}-${month}-${day}T${hour}:${minute}:${second}`);
  }

  // Utility: Create countdown string including days (conditionally) and German translation
  function getCountdownString(targetDate) {
    const now = toShopTime(new Date()); // Get the current time in shop's time zone
    const diff = Math.max(targetDate - now, 0);
    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);
  
    // Translate labels to German
    const daysLabel = days === 1 ? "Tag" : "Tage";
    const hoursLabel = hours === 1 ? "Stunde" : "Stunden";
    const minutesLabel = minutes === 1 ? "Minute" : "Minuten";
    const secondsLabel = seconds === 1 ? "Sekunde" : "Sekunden";
  
    // Construct the countdown string
    let countdown = "";
    if (days > 0) {
      countdown += `${days} ${daysLabel} `;
    }
    countdown += `${hours} ${hoursLabel} ${minutes} ${minutesLabel} ${seconds} ${secondsLabel}`;
  
    return countdown;
  }

  // Fixed message bar
  const messageBar = document.createElement('div');
  messageBar.style.cssText = `
    position: relative;
    top: 0;
    width: 100%;
    background-color: #ff4d4d;
    color: white;
    text-align: center;
    padding: 10px;
    z-index: 1000;
    font-size: 16px;
  `;
  document.body.prepend(messageBar);
  document.body.style.paddingTop = `${messageBar.offsetHeight}px`;

  // Check shop state and update UI
  function updateShopState() {
    const currentTime = toShopTime(new Date());
    if (shopClosed) {
      // Shop manually closed
      messageBar.textContent = "Der Shop ist aktuell geschlossen. Bitte versuche es später wieder.";
      disableButtons();

    } else if (registerOpenDateTime && currentTime < registerOpenDateTime){
      messageBar.textContent = `Die Registrierung startet in ${getCountdownString(registerOpenDateTime)}.`;
    } else if (shopOpenDateTime && currentTime < shopOpenDateTime) {
      // Countdown to opening
      messageBar.textContent = `Der Shop öffnet in ${getCountdownString(shopOpenDateTime)}.`;
      disableButtons();
    } else if (shopCloseDateTime && currentTime > shopCloseDateTime) {
      // Shop closed after closing time
      messageBar.textContent = "Der Shop ist aktuell geschlossen. Bitte versuche es später wieder.";
      disableButtons();
    } else if (shopOpenDateTime && shopCloseDateTime && currentTime < shopCloseDateTime && currentTime > shopOpenDateTime) {
      // Shop is open
      messageBar.textContent = `Der Shop schließt in ${getCountdownString(shopCloseDateTime)}.`;
      enableButtons();
    }
  }

  // Disable buttons (Add to Cart and Checkout)
  function disableButtons() {
    const addToCartButtons = document.querySelectorAll('form[action*="/cart/add"] button, .add-to-cart');
    const checkoutButtons = document.querySelectorAll('button[name="checkout"], .checkout-button');
    addToCartButtons.forEach((button) => {
      button.disabled = true;
      button.style.cursor = 'not-allowed';
      button.style.backgroundColor = '#ccc';
      //button.textContent = "Shop Closed";
    });
    checkoutButtons.forEach((button) => {
      button.disabled = true;
      button.style.cursor = 'not-allowed';
      button.style.backgroundColor = '#ccc';
      //button.textContent = "Checkout Disabled";
    });

    // Redirect if on checkout page
    if (window.location.pathname.includes('/checkout')) {
      window.location.href = '/';
    }
  }

  // Enable buttons
  function enableButtons() {
    const addToCartButtons = document.querySelectorAll('form[action*="/cart/add"] button, .add-to-cart');
    const checkoutButtons = document.querySelectorAll('button[name="checkout"], .checkout-button');
    addToCartButtons.forEach((button) => {
      button.disabled = false;
      button.style.cursor = 'pointer';
      button.style.backgroundColor = ''; // Restore original style
      //button.textContent = "Add to Cart";
    });
    checkoutButtons.forEach((button) => {
      button.disabled = false;
      button.style.cursor = 'pointer';
      button.style.backgroundColor = ''; // Restore original style
      //button.textContent = "Checkout";
    });
  }

  // Update the shop state every second
  updateShopState();
  setInterval(updateShopState, 1000);
});